import { render, staticRenderFns } from "./LoanRouter.vue?vue&type=template&id=6eb703c2"
import script from "./LoanRouter.vue?vue&type=script&lang=js"
export * from "./LoanRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports